const config = {
  apiKey: "AIzaSyBGzK-1fr0YLzHTlf_lok-zldvH9Sz4Wr4",
  authDomain: "react-superchat-40e43.firebaseapp.com",
  projectId: "react-superchat-40e43",
  storageBucket: "react-superchat-40e43.appspot.com",
  messagingSenderId: "127713533388",
  appId: "1:127713533388:web:dcd87673939be4e745d169",
  measurementId: "G-XM4VPT63RP",
}

export default config